<template>
    <EntityLink
      v-if="entity && module && canRead(module)"
      :entity="entity"
      :load-entity="true"
    />
    <span v-else-if="entity && entity.brezel_name">
      <i>{{ entity.brezel_name }}</i>
    </span>
    <span v-else>System</span>
</template>

<script>
import Entity from '@/api/entity'
import EntityLink from '@/components/EntityLink'
import { canRead } from '@/guard'

export default {
  name: 'Performer',
  components: {
    EntityLink,
  },
  computed: {
    entity () {
      return this.data ? new Entity(this.data) : null
    },
    module () {
      return this.entity ? this.$store.getters.getModuleById(this.entity.module_id) : null
    }
  },
  props: {
    data: {
      type: Object,
      default: undefined,
    },
  },
  methods: {
    canRead,
  },
}
</script>
